var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKettlebellAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.60471 6.18585C3.7953 3.75761 5.60269 1.25 8.16228 1.25H15.8377C18.3973 1.25 20.2047 3.75761 19.3953 6.18585L18.1559 9.90399C19.3075 11.2964 20 13.0858 20 15.0376C20 17.916 18.4941 20.441 16.2307 21.8607C16.0812 21.9545 15.907 22 15.7305 22H8.26949C8.09298 22 7.91885 21.9545 7.76932 21.8607C5.5059 20.441 4 17.916 4 15.0376C4 13.0858 4.69249 11.2964 5.84409 9.90399L4.60471 6.18585ZM8.16228 2.75C6.62652 2.75 5.54209 4.25457 6.02774 5.71151L7.03541 8.73453C8.39951 7.64851 10.1244 7 12 7C13.8756 7 15.6005 7.64851 16.9646 8.73453L17.9723 5.71151C18.4579 4.25457 17.3735 2.75 15.8377 2.75H8.16228ZM12.1241 9.34334C11.7156 9.27481 11.3289 9.55041 11.2603 9.95892C11.1918 10.3674 11.4674 10.7541 11.8759 10.8227C14.0729 11.1913 15.8088 12.9271 16.1774 15.1241C16.2459 15.5326 16.6326 15.8082 17.0411 15.7397C17.4496 15.6712 17.7252 15.2845 17.6567 14.876C17.1823 12.048 14.9521 9.81779 12.1241 9.34334Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKettlebellAlt);
export default __webpack_public_path__ + "static/media/kettlebell-alt.95a4eff5b9fa73019fae5bee3cc9e979.svg";
export { ForwardRef as ReactComponent };